document.addEventListener("DOMContentLoaded", function () {
    const kitData = {
        "6_bottle": [
            { "variantId": "42289430790249", "sellingPlanId": "1638137961", "quantity": 1 },
            { "variantId": "42301613736041", "quantity": 1 },
            { "variantId": "42301613801577", "quantity": 1 },
            { "variantId": "42273617838185", "quantity": 1 }
        ],
        "4_bottle": [
            { "variantId": "42289430790249", "sellingPlanId": "1638137961", "quantity": 1 },
            { "variantId": "42301613736041", "sellingPlanId": "", "quantity": 1 },
            { "variantId": "42273617838185", "sellingPlanId": "", "quantity": 1 }
        ],
        "12_bottle": [
            { "variantId": "42289430790249", "sellingPlanId": "1638137961", "quantity": 1 },
            { "variantId": "42301613736041", "sellingPlanId": "", "quantity": 1 },
            { "variantId": "42301613801577", "sellingPlanId": "", "quantity": 1 },
            { "variantId": "42336737624169", "sellingPlanId": "", "quantity": 1 },
            { "variantId": "42273617838185", "sellingPlanId": "", "quantity": 1 }
        ]
    };

    const buttons = document.querySelectorAll(".sc-join-community-btn");
    buttons.forEach(button => {
        button.addEventListener("click", async (e) => {
            e.preventDefault();
            const kitType = button.dataset.kit;
            const items = kitData[kitType];

            if (!items || !Array.isArray(items)) {
                console.warn("No items configured for:", kitType);
                return;
            }

            const formattedItems = items.map(item => ({
                id: item.variantId,
                quantity: item.quantity,
                ...(item.sellingPlanId && { selling_plan: item.sellingPlanId })
            }));

            try {
                await fetch("/cart/clear.js", { method: "POST" });
                const res = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Accept": "application/json" },
                    body: JSON.stringify({ items: formattedItems, sections: ['ajax-cart'] }),
                });

                const cartResponse = await res.json();

                if (!res.ok || cartResponse.status === 'error') {
                    fgLogError("Shopify API Error: Failed to add to cart:", cartResponse)
                    console.error("API Error: Failed to add to cart:", cartResponse.message || cartResponse.error);
                    throw new Error(`Failed to add items to cart. Error: ${cartResponse.message || cartResponse.error || "Unknown error"}`);
                }

                if (!cartResponse.items) {
                    fgLogError("Shopify API Error: Failed to add to cart:", cartResponse)
                    throw new Error("No items returned in response. Failed to update cart.");
                }

                fgLogInfo("joinKitHandler successful run");

                window.location.href = "/pages/consultant-signup";
                return;
            } catch (err) {
                console.error("Error handling join kit:", err);
            }
        });
    });
});
